export type SuperAdminSession = {
  role?: string | null;
  salonId?: number | string | null;
};

export function hasSuperAdminAccess(user: SuperAdminSession | null | undefined): boolean {
  return user?.role === "superadmin";
}
